import router from './router'
import Layout from '@/views/index'
import store from './store'
const menuData = require('./layout/menu2.js')
const _import = require('./router/_import_development.js')
// 路由守卫
router.beforeEach(async (to, from, next) => {
  const isLogin = localStorage.getItem('token') ? true : false;
  // const isLogin = getToken()
  if (to.path == '/login') {
    next();
  } else {
    // 是否在登录状态下
    // isLogin ? next() : next('/login');
    if (isLogin) {
      if (!global.antRouter || global.antRouter.length == 0) {
        global.antRouter = []
        // 动态路由 过滤路由
        await store.dispatch('getqueryUserMenuList')
        let menus = filterAsyncRouter(store.state.app.queryUserMenuList)
        // 模拟路由
        // let menus = filterAsyncRouter(menuData.data)
        if (menus && menus.length > 0) { //判断用没用菜单权限 防止死循环
          router.addRoutes(menus)
          next({
            ...to,
            replace: true
          })
          next();
          global.antRouter = menus
        } else {
          next();
        }
      }
      next();
    } else {
      next('/login')
    }
  }
});
//遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  let accessedRouters = asyncRouterMap.filter((route, index) => {
    if (route.name) {
      route.name = route.name
    }
    if (route.component) {
      if (route.component == 'Layout') {
        route.component = Layout
      } else {
        route.component = require(`@/views/${route.component}.vue`).default

      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })
  return accessedRouters
}



// WEBPACK FOOTER //
// ./src/permission.js